export default "__VITE_ASSET__3XIk0btY__"